import React, { useRef, useState, useEffect } from 'react'
import Header from '../../Components/Header'
import { Col, Container, Row } from 'react-bootstrap'
import Sidebar from '../../Components/Sidebar'
import { toastAlert } from "../../lib/toastAlert";
import { useNavigate } from 'react-router-dom';
import Totalnft from "../../assets/images/totalnft.png";
import { getCMSlist } from '../../actions/users';

const CmsNewList = () => {
    const navigate = useNavigate()
    const [userdata, setuserdata] = useState([])

    useEffect(() => {
        getCmsList();
    }, [])

    const getCmsList = async () => {
        var test = await getCMSlist();
        if(test.Success)
        setuserdata(test.userValue)
        else
          toastAlert("error", "Error on Server")
    }

    return (
        <>
          <Container fluid className='common_bg position-relative'>
            <div className='liner'></div>
            <Row>
              <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                <Sidebar />
              </Col>
              <Col xl={10} lg={12}>
                <Header title={'CMS'} />

                <div className='common_page_scroller mt-4 mt-sm-5 pe-2'>
                  <Row className=''>
                  {userdata && userdata.length > 0 &&
                    userdata.filter((cms)=> cms.question !== "MidSec").map((cms)=>{
                        return(
                            <Col lg={4} md={12} sm={6} className='mt-4 mb-4 mb-lg-0'>
                            <div className='dashboard_box p-3 rounded-3 d-flex align-items-center justify-content-between gap-4'>                          
                              <div>
                                <p className='text-white'>Content In</p>
                                <h5 className='text-white mb-0'>{cms.question} <small>CMS</small></h5>
                              </div>
                              <button type='button' className='btn addcate mb-0' onClick={()=>{navigate('/midcmslist/'+cms.question)}}>View</button>
                            </div>
                          </Col>
                        )
                    })
                    }
                        <Col lg={4} md={12} sm={6} className='mt-4 mb-4 mb-lg-0' onClick={()=>navigate('/Midcmslist/edit/'+userdata.filter((cms)=> cms.question === "MidSec")[0].question)}>
                          <div className='dashboard_box p-3 rounded-3 d-flex align-items-center justify-content-between gap-4'>
                          <div>
                              <p className='text-white'>Content In</p>
                              <h5 className='text-white mb-0'>home Banner Image</h5>
                            </div>
                           <button type='button' className='btn addcate mb-0'>View</button>
                           
                          </div>
                        </Col>
                  </Row>
                </div>
                <div>
    
                </div>
              </Col>
            </Row>
          </Container>
        </>
      )
}

export default CmsNewList